import service from '@/utils/request.js';

//代理信息
export function getAgents(params){
    return service({
        url:'api/selectAgentList',
        method:'get',
        params
    })
}

//店铺信息
export function getShopDetail(params){
    return service({
        url:'api/shopInfo',
        method:'get',
        params
    })
}

// 店铺商品
export function getShopCommodity(params){
    return service({
        url:'api/spuInfoList',
        method:'get',
        params
    })
}

// 店铺类目列表
export function getShopCategoryList(params){
    return service({
        url:'api/shopCategoryList',
        method:'get',
        params
    })
}

// 类目产品列表
export function cateCommodList(params){
    return service({
        url:'api/categorySpuList',
        method:'get',
        params
    })
}

// 获取省市区
export function getCity(params){
	return service({
	    url:'api/getArea',
	    method:'get',
	    params
	})
}

// 商品详情
export function getCommodity(params){
    return service({
        url:'api/spuInfo',
        method:'get',
        params
    })
}

// 订单列表
export function orderList(params){
    return service({
        url:'api/orderList',
        method:'get',
        params
    })
}

// 提交订单
export function submitOrder(params){
    return service({
        url:'api/createOrder',
        method:'post',
        data:params
    })
}

// 产品协议
export function agreement(params){
    return service({
        url:'api/spuAgreement',
        method:'get',
        params
    })
}

